var map = {
	"./customer_service.jpg": "113a",
	"./img/aboutbg.054cc8b.jpg": "679e",
	"./img/banner1.jpg": "2fe0",
	"./img/banner2.jpg": "cefb",
	"./img/bgcenter.c1d3caa.jpg": "5932",
	"./img/bottom_bg.90c1ea1.jpg": "c39a",
	"./img/callme.jpg": "335a",
	"./img/callme2.jpg": "c1b6",
	"./img/cover.jpg": "9868",
	"./img/cxbg1.9bc83c9.jpg": "253d",
	"./img/cydcbg.80d9b0b.jpg": "8d0d",
	"./img/introBg.40f79db.jpg": "f55f",
	"./img/newbg.22e89fc.jpg": "e09e",
	"./img/ryzz.bc140e4.jpg": "fdb6",
	"./img/solition_level.83f545d.jpg": "c59a",
	"./img/zxbg.e5bb377.jpg": "07b5",
	"./logo.jpg": "b640",
	"./xdzht.jpg": "d6c1",
	"./xgNursingHome.jpg": "11c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";